import React from 'react';
import SkillBar from 'react-skillbars';
import style from './Skills.module.scss';
const Skills = () => {
  const skills = [
    {
      "type": "Javascript",
      "level": 95,
      "color": {
        "bar": "#3498db",
        "title": {
          "text": "#fff",
          "background": "#2980b9"
        }
      }
    },
    {
      "type": "React",
      "level": 90,
      "color": {
        "bar": "#4288d0",
        "title": {
          "text": "#fff",
          "background": "#124e8c"
        }
      }
    },
    {
      "type": "C",
      "level": 85,
      "color": {
        "bar": "#2c3e50",
        "title": {
          "text": "#fff",
          "background": "#2c3e50"
        }
      }
    },
    {
      "type": "Node",
      "level": 80,
      "color": {
        "bar": "#5a68a5",
        "title": {
          "text": "#fff",
          "background": "#46465e"
        }
      }
    },
    {
      "type": "MongoDb",
      "level": 77,
      "color": {
        "bar": "#525252",
        "title": {
          "text": "#fff",
          "background": "#333333"
        }
      }
    },
    {
      "type": "Bootstrap",
      "level": 70,
      "color": {
        "bar": "black",
        "title": {
          "text": "#111",
          "background": "#fff"
        }
      }
    },
    {
      "type": "Material UI",
      "level": 60,
      "color": {
        "bar": "#2ecc71",
        "title": {
          "text": "#fff",
          "background": "#27ae60"
        }
      }
    }
  ];
  return (
    <div className={style.skills} id="skills">
      <div className="container ">
        <div className="text-center">
          <h1 className="mb-3">My Skills</h1>

          <div className="row">
            <div className="col-md-2 col-sm-12"></div>

            <div className="col-md-8 col-sm-12">
            <div className="shadow-lg p-4 rounded">
          <div  className={style.mySkillPadding}>
          <SkillBar skills={skills}  animationDelay={100}  animationDuration={7000}/>  
           </div>
          </div>
            </div>

            <div className="col-md-2 col-sm-12"></div>
          </div>


           
        </div>
      </div>
    </div>
  );
};

export default Skills;